import { Component, Input, Output, OnChanges, EventEmitter, SimpleChanges } from '@angular/core';
import { PtLuxonDate } from '../../../../models/projects/date.models';

@Component({
  selector: 'pt-offset-picker',
  templateUrl: 'pt-offset-picker.html'
})
export class PtOffsetPickerComponent implements OnChanges {
  @Input() loading: boolean;
  @Input() ptLuxonDate: PtLuxonDate;
  @Input() offset?: number; // offset is in minutes
  @Input() disabled?: boolean;
  @Output() offsetSelected = new EventEmitter<PtLuxonDate>();

  possibleOffsets: number[]; // possible offsets will be in seconds
  selectedOffset: number; // selected offset is in hours

  options = {
    title: 'Possible Offsets',
    mode: 'md'
  };

  constructor() {
  }

  ngOnChanges(...args: SimpleChanges[]) {
    // when viewing the edit screen, we want to load in the previously selected offsets that the user chose
    if (this.ptLuxonDate && this.ptLuxonDate.multipleOffsets && this.ptLuxonDate.multipleOffsets.possibleOffsets && this.ptLuxonDate.multipleOffsets.selectedOffsetMinutes != null) {
      const index = this.ptLuxonDate.multipleOffsets.possibleOffsets.findIndex(e => e === this.offset * 60);

      if (index !== -1) {
        this.selectedOffset = this.ptLuxonDate.multipleOffsets.possibleOffsets[index];
      }
    }

    // if user enters a time that has multiple offsets, then this.offset will get set to null, so we want to make sure to null the dropdown
    if (this.offset == null || !this.ptLuxonDate || !this.ptLuxonDate.multipleOffsets || this.ptLuxonDate.multipleOffsets.selectedOffsetMinutes == null) {
      this.selectedOffset = null;
    }
  }

  emitSelection() {
    if (this.selectedOffset != null) {
      this.ptLuxonDate.setOffset(this.selectedOffset, true);
      this.ptLuxonDate.multipleOffsets.selectedOffsetMinutes = this.selectedOffset * 60;
      this.offsetSelected.emit(this.ptLuxonDate);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/shared/components/pt-offset-picker/pt-offset-picker.ts